import { HttpErrorResponse } from '@angular/common/http';
import { createFeature, createReducer, on } from '@ngrx/store';
import { emailChangeActions, emailChangeApiActions } from './email-change.actions';

interface EmailChange {
  started: boolean;
  requestId: string;
  error: HttpErrorResponse | null;
  tanVerified: boolean;
  oldEmailVerified: boolean;
  oldEmailError: boolean;
  newEmailVerified: boolean;
  newEmailError: boolean;
}

export interface EmailChangeState {
  readonly emailChange: EmailChange;
}

const initialState: EmailChange = {
  started: false,
  requestId: null,
  error: null,
  oldEmailVerified: null,
  oldEmailError: null,
  newEmailVerified: null,
  newEmailError: null,
  tanVerified: null,
};

export const emailChangeFeature = createFeature({
  name: 'emailChange',
  reducer: createReducer(
    initialState,
    on(
      emailChangeApiActions.startProcessSuccess,
      (state, { requestId }): EmailChange => ({ ...state, requestId, started: true, error: null }),
    ),
    on(emailChangeApiActions.startProcessFailure, (state, { error }): EmailChange => ({ ...state, error })),
    on(emailChangeActions.requestTan, (state): EmailChange => ({ ...state, error: null })),
    on(emailChangeActions.verify, (state): EmailChange => ({ ...state, error: null })),
    on(emailChangeActions.verifyOldEmail, (state): EmailChange => ({ ...state, error: null })),
    on(
      emailChangeApiActions.verifyOldEmailSuccess,
      (state, response): EmailChange => ({
        ...state,
        oldEmailVerified: response.interested,
        oldEmailError: !response.interested,
        error: null,
      }),
    ),
    on(emailChangeApiActions.verifyOldEmailFailure, (state, { error }): EmailChange => ({ ...state, error })),
    on(emailChangeActions.verifyNewEmail, (state): EmailChange => ({ ...state, error: null })),
    on(
      emailChangeApiActions.verifyNewEmailSuccess,
      (state, response): EmailChange => ({
        ...state,
        newEmailVerified: response.interested,
        oldEmailError: !response.interested,
        error: null,
      }),
    ),
    on(emailChangeApiActions.verifyNewEmailFailure, (state, { error }): EmailChange => ({ ...state, error })),
    on(emailChangeActions.abortProcess, (state): EmailChange => ({ ...state, error: null })),
    on(emailChangeApiActions.abortProcessSuccess, (): EmailChange => ({ ...initialState, error: null })),
    on(emailChangeApiActions.abortProcessFailure, (state, { error }): EmailChange => ({ ...state, error })),
  ),
});
